import React from "react";
import ReactDOM from "react-dom";
import App from "./App";


const root = document.getElementById("threed-configurator");
const appWrapper = document.createElement("div");
appWrapper.id = "app-wrapper";
root.appendChild(appWrapper);
ReactDOM.render( <App />, appWrapper );
